import styled from 'styled-components';
import { Button } from 'components';
import { TONE_SURFACES } from 'widgets/audio/toneSurfaces';

export type BillingScheinBannerTone = 'warning' | 'success';

const TONE_CLASSES: Record<BillingScheinBannerTone, string> = {
  warning: TONE_SURFACES.warning,
  success: 'bg-emerald-600 text-white',
};

export const BannerBox = styled.div.attrs<{ $tone: BillingScheinBannerTone }>(({ $tone }) => ({
  className: `flex w-full items-center gap-2 px-2.5 py-2 ${TONE_CLASSES[$tone]}`,
}))<{ $tone: BillingScheinBannerTone }>``;

export const BannerContent = styled.div.attrs({
  className: 'flex min-w-0 flex-1 items-start gap-2',
})``;

export const BannerIconSlot = styled.span.attrs({
  className: 'flex shrink-0 pt-0.5 [&_svg]:size-4',
  'aria-hidden': true,
})``;

export const BannerText = styled.div.attrs({
  className: 'flex min-w-0 flex-1 flex-col gap-0.5 text-sm',
})``;

export const BannerTitle = styled.p.attrs({
  className: 'truncate font-semibold',
})``;

export const BannerDescription = styled.p.attrs({
  className: 'opacity-70',
})``;

export const RecheckButton = styled(Button).attrs({
  variant: 'outline',
  size: 'xs',
  className: 'shrink-0 border-primary bg-white py-0 text-primary',
})``;

export const DismissButton = styled.button.attrs({
  type: 'button',
  className:
    'flex size-6 shrink-0 items-center justify-center rounded-md hover:bg-white/30 [&_svg]:size-5',
})``;
